import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { NavLink } from 'react-router-dom';
import { PersonInfo } from '../Interface/Interface';
import profile from '../images/pngwing.com.png'

export default function PersonDetailes() {
    const [person, setPerson] = useState<PersonInfo>()
    const [loading, setLoading] = useState(false);

    const storageId = sessionStorage.getItem('movieID');

    useEffect(() => {

        if (storageId != null) {
            getDetails(storageId);
            setLoading(true)
        }




    }, [])


    async function getDetails(storageId: string) {

        const { data } = await axios.get(`https://api.themoviedb.org/3/person/${storageId}?api_key=52554469fe208e948caaf074d2683e95&language=en-US`);


        setPerson(data)

        setLoading(false)
    }


    return (<> {loading ? <div className='loaddrComtainer '>
        <span className="loader"></span>
    </div> : <div className="row py-4">

        <div className="col-md-4">
            {person?.profile_path ? <img src={`https://image.tmdb.org/t/p/w500/` + person?.profile_path} className='img-fluid' alt={person.name} /> : <img src={profile} className='img-fluid' alt={person?.name} />}

        </div>
        <div className="col-md-8">
            <h2 >{person?.name}</h2>

            <div className='px-3  '>

                <ul className='list-unstyled py-2'>
                    <li className='py-2'> known for department :  {person?.known_for_department}</li>
                    {person?.place_of_birth ? <li className='py-2'>place_of_birth  :  {person?.place_of_birth}</li> : ''}

                    <li className='py-2'> Popularity :  {person?.popularity}</li>




                </ul>
                <p className='text-muted'> {person?.biography}</p>
            </div>

            {person?.homepage ? <a href={person?.homepage} target="_blank"  > <button className='btn btn-outline-primary  '> Home page <i className="fa-solid fa-film px-1"></i> </button></a> : " "}
            <NavLink to={'/people'}> <button className='btn btn-outline-success mx-2'> watch more movies</button> </NavLink>

        </div>

    </div>}

    </>

    )
}
